const t = "_innerWrapper_7lnm5_1", o = "_textStart_7lnm5_5", n = "_topLogo_7lnm5_8", r = {
  innerWrapper: t,
  textStart: o,
  topLogo: n
};
export {
  r as default,
  t as innerWrapper,
  o as textStart,
  n as topLogo
};
